module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABCUAAABZAQMAAAAzaQx4AAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAZQTFRFaVnJAAAAtNrrawAAAAJ0Uk5TGgDGvjfjAAAAiklEQVR4nO3WIQ4CQRBFwXUcg6NyNm6ERJAMWcMzZO20qKdalunkH7f1ua/XYz3X2nYeBwXFP8Ua0JviF0VRFEVRFEVR1BTFjJVDQWH9XkVRFEVRFEVRFEVR1i/FZMXu/zib8qm7BWcURVEURVEURVFTFDNWDgWF9XsVRVEURVEURVEURVm/FIMVXxjH2bMAdCXYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-icon_3.png
// module id = Jtyg
// module chunks = 0